import types from '../types/types';

const initialState = {
  totalShippingCost: 0,
  shippingTax: 0,
};
const shippingCostReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.shippingCost:
      return {
        ...state,
        totalShippingCost: action.totalShippingCost,
        shippingTax: action.shippingTax,
      };

    default:
      return state;
  }
};
export default shippingCostReducer;
